export enum ProductType {
   Process = 1,
   Evolve,
   Complete,
   Reference,
}
